// extracted by mini-css-extract-plugin
var _1 = "TeamIconEditor-module__animateUploadProgressBarWidth--NRn0a";
var _2 = "TeamIconEditor-module__animatedBackground--cL1Ha";
var _3 = "TeamIconEditor-module__label--ei7GM";
export { _1 as "animateUploadProgressBarWidth", _2 as "animatedBackground", _3 as "label" }
